import { FileInput, FileField } from 'ra-ui-materialui'
import React from 'react'
import KAccordion from 'ui-shared/accordions/KAccordion'

type Props = {
  source: string
  accept?: string
  multiple?: boolean
  label?: string
}

const KFileInput: React.FC<Props> = ({
  source,
  accept = 'application/pdf',
  multiple,
  label,
}) => {
  return (
    <KAccordion accordionTitle="Documents">
      <FileInput
        placeholder={`Drop a file to upload, or click to select it (only ${accept} format allowed)`}
        source={source}
        label={label}
        accept={accept}
        multiple={multiple}
      >
        <FileField source="src" title="title" target="_blank" />
      </FileInput>
    </KAccordion>
  )
}

export default KFileInput
